import { AwsCrc32 } from "@aws-crypto/crc32";
export var getCrc32ChecksumAlgorithmFunction = function getCrc32ChecksumAlgorithmFunction() {
  return AwsCrc32;
};